;(function ($, window, document) {
    window.Header = Me.view.extend({
        options: {
            antispam: false
        },

        initialize: function () {
            _.bindAll(this, 'scrollHandler', 'closeSearch', 'updateActiveLink', 'expandSubmenu', 'keypressHandler', 'closeSubmenu', 'preventClick', 'toggleMobileMenu', 'searchHandler');


            this.updateActiveLink();

            this.isHome = false;
            this.hasAlternateColor = false;

            if (this.$('header').hasClass('top-of-homepage')) {
                this.isHome = true;
            }
            if (this.$('header').hasClass('alternate-color')) {
                this.hasAlternateColor = true;
            }
            this.addEvents();
            this.manageSticky();
        },
        addEvents: function (e) {
            
          	let pageLoaded;
			let insideBox = false;
          
            let mousex = 0;
            let mousey = 0;
          
//          	document.addEventListener("mousemove", () => {
//                 mousex = event.clientX;
//   				mousey = event.clientY;
                                      
//             });
          
//           	console.log( mousex);
//        		console.log( mousey);
          
//     		elementMouseIsOver = document.elementFromPoint(mousex, mousey);
           
            $(window).on('scroll', this.scrollHandler);
            $(window).on('resize', this.resizeHandler);
            $(window).on('orientationchange', this.resizeHandler);
            this.$('.close-button').on('click', this.closeSearch);
            this.scrollHandler();
          
          
            if(!Me.detect.isIpad()){
//               	$(elementMouseIsOver).trigger('mouseenter');
              
                this.$('.nav-main-links>li').on('mouseenter', this.expandSubmenu);
                this.$('.nav-main-links>li').on('mouseleave', this.closeSubmenu);
            }else{
                this.$('.nav-main-links .tablet-clickthrough').on('click', this.preventClick);
            }

            this.$('.nav-trigger').on('click', this.toggleMobileMenu);
            this.$('.icon.search').on('click', this.searchHandler);
            Me.dispatch.subscribe('Cart.quantityUpdated', this.updateCartCount);
        },
        closeSearch: function(e){

            if($(e.target).parents('#section-header').length == 0 || $(e.currentTarget).hasClass('close-button')){
                this.$('nav').css('width', '');
                this.$el.removeClass('searching');
                $('body').off('click', this.closeSearch);
                $(window).off('keydown', this.keypressHandler);
            }
        },
        keypressHandler: function(e){
            if(e.keyCode == 27){
                //escape
                this.closeSearch($('body'));
            }else if(e.keyCode == 13){
                //enter: search
                this.launchSearch();
            }
        },
        launchSearch: function(){
            location = this.$('.icon.search').attr('data-search-service') + this.$('input').val();
        },
        preventClick: function(e){
            //prevent clicking on first lvl buttons on ipad so we can access sublevels links.
            if($(e.currentTarget).hasClass('tablet-clickthrough') && Me.detect.isIpad()){
                e.preventDefault();
                this.expandSubmenu(e);
            }
        },
        scrollHandler: function () {

            this.manageSticky();

            if (this.isHome) {
                if ($(window).scrollTop() > 1) {
                    this.$('header').removeClass('top-of-homepage');
                } else {
                    this.$('header').addClass('top-of-homepage');
                }
            }

            if (this.hasAlternateColor) {
                if ($(window).scrollTop() > 1) {
                    this.$('header').removeClass('alternate-color');
                } else {
                    this.$('header').addClass('alternate-color');
                }
            }
        },
        searchHandler: function(){
            var view = this;
            if(this.$el.hasClass('searching')){
                this.launchSearch();
            }else{
                this.$('nav').css('width', this.$('.nav-main-links').width());
                setTimeout(function(){

                    view.$el.addClass('searching');
                    $('body').on('click', view.closeSearch);
                    view.$('input').trigger('focus');
                    $(window).on('keydown', view.keypressHandler);
                }, 10)

            }
        },
        updateActiveLink: function () {
            this.$('ul li').each(function (index, value) {
                if ($(value).find('.current-page').length != 0) {
                    $(value).addClass('current-page');
                }
            });
        },

        expandSubmenu: function (e) {
          
         	$(e.currentTarget).addClass('hover');
          
            if ($(e.currentTarget).find('.submenu').height()) {
                this.$('.submenu-height').css('height', $(e.currentTarget).find('.submenu').outerHeight(true));
            } else if($(e.currentTarget).siblings('.submenu').height()) {
                this.$('.submenu-height').css('height', $(e.currentTarget).siblings('.submenu').outerHeight(true));
            } else {
                this.$('.submenu-height').css('height', 0);
            }
        },
        toggleMobileMenu: function (e) {
            this.$('header').toggleClass('open');
            $('#header-mobile').toggleClass('open');

            if (this.$('header').hasClass('open')) {
                $('#header-mobile').css('height', $(window).height());
                $('body, html').css('overflow', 'hidden');
            } else {
                $('#header-mobile').css('height', '0px');
                $('body, html').css('overflow', 'auto');
            }
        },
        closeSubmenu: function (e) {
          
            $(e.currentTarget).removeClass('hover');          
            this.$('.submenu-height').css('height', 0);
            
        },
        manageSticky: function () {
            var scrollPosition = $(window).scrollTop();
            var stickyPosition = 0;
            var $previousElements = this.$el.prevAll();

            if ($previousElements.length > 0) {
                $previousElements.each(function (index) {
                    var $previousElement = $(this);
                    if (!$previousElement.is(':visible') || $previousElement.css('position') !== 'relative') {
                        return true;
                    }

                    stickyPosition += parseInt($previousElement.outerHeight());
                });
            }

            if (scrollPosition > stickyPosition && !this.$el.hasClass('fixed')) {
                this.$el.addClass('fixed');
                this.$('#coquo-logo').find('svg g').css('fill', '#57544E');
            } else if (scrollPosition <= stickyPosition && this.$el.hasClass('fixed')) {
                this.$el.removeClass('fixed');
                if(this.$('#coquo-logo').attr('data-logo-color')){
                    this.$('#coquo-logo').find('svg g').css('fill', this.$('#coquo-logo').attr('data-logo-color'));
                }
            }
        },
        resizeHandler: function () {
            if (this.$('header').hasClass('open')) {
                $('#header-mobile').css('height', $(window).height());
            }
        }
    });
}(jQuery, window, document));
